var _rect, _path, _defs;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#F2F3F9",
    rx: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#32a)",
    fillRule: "evenodd",
    d: "M32.005 17.113a3.22 3.22 0 0 1 .766 3.449l-1.7 4.613c-.448 1.207-1.46 2.147-2.718 2.393a3.54 3.54 0 0 1-3.42-1.222L14.76 14.156a.23.23 0 0 0-.318-.03.2.2 0 0 0-.065.095l-3.311 8.958a.227.227 0 0 0 .296.29l4.063-1.656a1.795 1.795 0 0 1 2.336.99c.014.043.036.087.043.13.304.919-.202 1.916-1.091 2.278l-5.308 2.169c-.983.405-2.11.332-2.993-.26a3.22 3.22 0 0 1-1.23-3.803l3.912-10.578a3.65 3.65 0 0 1 2.828-2.365 3.63 3.63 0 0 1 3.448 1.273l5.842 6.999 5.373-2.198c1.185-.5 2.494-.239 3.42.665m-3.102 3.521a.227.227 0 0 0-.297-.29l-2.964 1.215 1.779 2.133c.079.094.216.109.318.03a.3.3 0 0 0 .065-.095z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "32a",
    x1: 4.759,
    x2: 20.756,
    y1: 11.778,
    y2: 35.778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8E3C"
  })))));
});
const SvgAirwallex = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAirwallex);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiByeD0iMjAiIGZpbGw9IiNGMkYzRjkiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zMi4wMDQ1IDE3LjExMjlDMzIuOTIyOCAxOC4wMDk0IDMzLjIyNjQgMTkuMzYxNSAzMi43NzA5IDIwLjU2MTdMMzEuMDcxOCAyNS4xNzQ2QzMwLjYyMzUgMjYuMzgyMSAyOS42MTEzIDI3LjMyMiAyOC4zNTMyIDI3LjU2NzlDMjcuMDczNSAyNy44MjA5IDI1Ljc1NzUgMjcuMzUxIDI0LjkzMzMgMjYuMzQ1OUwxNC43NjAzIDE0LjE1NTdDMTQuNjgwNyAxNC4wNjE3IDE0LjUzNjEgMTQuMDQ3MiAxNC40NDIxIDE0LjEyNjhDMTQuNDEzMiAxNC4xNDg1IDE0LjM5MTUgMTQuMTg0NiAxNC4zNzcxIDE0LjIyMDhMMTEuMDY1NiAyMy4xNzkxQzExLjAwMDUgMjMuMzY3MSAxMS4xODEzIDIzLjU0MDYgMTEuMzYyIDIzLjQ2ODNMMTUuNDI1NSAyMS44MTI2QzE2LjM0MzcgMjEuNDQzOCAxNy4zOTIxIDIxLjg4NDkgMTcuNzYwOCAyMi44MDMxQzE3Ljc3NTMgMjIuODQ2NSAxNy43OTcgMjIuODg5OSAxNy44MDQyIDIyLjkzMzNDMTguMTA3OSAyMy44NTE1IDE3LjYwMTggMjQuODQ5MyAxNi43MTI1IDI1LjIxMDhMMTEuNDA1NCAyNy4zNzk5QzEwLjQyMjEgMjcuNzg0OCA5LjI5NDE4IDI3LjcxMjUgOC40MTIwOCAyNy4xMTk2QzcuMTY4NDcgMjYuMjg4MSA2LjY2MjM1IDI0LjcxOTEgNy4xODI5MyAyMy4zMTY1TDExLjA5NDUgMTIuNzM4NkMxMS41NTczIDExLjQ4NzcgMTIuNjEyOSAxMC41OTg0IDEzLjkyMTYgMTAuMzc0M0MxNS4yMTU4IDEwLjE0MjkgMTYuNTMxNyAxMC42MjczIDE3LjM3MDQgMTEuNjQ2OEwyMy4yMTI1IDE4LjY0NTdMMjguNTg0NiAxNi40NDc3QzI5Ljc3MDMgMTUuOTQ4OCAzMS4wNzkgMTYuMjA5MSAzMi4wMDQ1IDE3LjExMjlaTTI4LjkwMjcgMjAuNjM0QzI4Ljk2NzggMjAuNDQ2IDI4Ljc4NyAyMC4yNzI1IDI4LjYwNjMgMjAuMzQ0OEwyNS42NDE5IDIxLjU1OTVMMjcuNDIwNSAyMy42OTI0QzI3LjUgMjMuNzg2NCAyNy42Mzc0IDIzLjgwMDkgMjcuNzM4NiAyMy43MjEzQzI3Ljc2NzYgMjMuNjkyNCAyNy43ODkzIDIzLjY2MzUgMjcuODAzNyAyMy42Mjc0TDI4LjkwMjcgMjAuNjM0WiIgZmlsbD0idXJsKCNwYWludDBfbGluZWFyXzE4NTFfNDExMjgpIi8+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfMTg1MV80MTEyOCIgeDE9IjQuNzU5MjQiIHkxPSIxMS43NzgzIiB4Mj0iMjAuNzU1OSIgeTI9IjM1Ljc3NzciIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iI0ZGNDI0NCIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiNGRjhFM0MiLz4KPC9saW5lYXJHcmFkaWVudD4KPC9kZWZzPgo8L3N2Zz4K";